"use strict";

(function () {
	var self;

	var adpPopup = {
		sPrevious: window.scrollY,
		sDirection: 'down',

		/*
		* Initialize
		*/
		init: function () {
			self = adpPopup;

			self.popupInit();

			// Init events.
			self.events();
		},

		/*
		* Events
		*/
		events: function () {
			document.addEventListener('click', function (e) {
				var closeEl = e.target.closest('.popup-close');
				var acceptEl = e.target.closest('.popup-accept');
				var ageCloseEl = e.target.closest('.age-verification__popup-close');
				var ageNoEl = e.target.closest('.age-verification__button-no');
				var overlayEl = e.target.closest('.popup-overlay');

				if (closeEl) self.closePopup(closeEl);
				if (acceptEl) {
					self.acceptPopup(acceptEl);
					self.closePopup(acceptEl);
				}
				if (ageCloseEl) {
					self.agePopup(ageCloseEl);
					self.closePopup(ageCloseEl);
				}
				if (ageNoEl) self.ageDeclined();
				if (overlayEl) {
					document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function (popup) {
						self.closePopup(popup);
					});
				}
			});

			document.addEventListener('keyup', function (e) {
				if (e.key === 'Escape') {
					document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (popup) {
						self.closePopup(popup);
					});
				}
				if (e.key === 'F4') {
					document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (popup) {
						self.closePopup(popup);
					});
				}
			});
		},

		/*
		* Init popup elements
		*/
		popupInit: function () {

			// Set scroll direction.
			document.addEventListener('scroll', function () {
				var scrollCurrent = window.scrollY;
				self.sDirection = scrollCurrent > self.sPrevious ? 'down' : 'up';
				self.sPrevious = scrollCurrent;
			});

			// Open popup
			document.querySelectorAll('.popup').forEach(function (popup) {

				// Manual Launch.
				if ('manual' === popup.dataset.openTrigger) {
					var selector = popup.dataset.openManualSelector;

					if (selector) {
						document.querySelectorAll(selector).forEach(function (el) {
							el.classList.add('popup-trigger');
						});

						document.addEventListener('click', function (e) {
							var matchedEl = e.target.closest(selector);
							if (!matchedEl) return;

							e.preventDefault();

							popup.classList.remove('popup-already-opened');

							self.openPopup(popup);

							if (matchedEl.classList.contains('popup')) {
								self.closePopup(matchedEl);
							}
						});
					}
				}

				// Checks whether a popup should be displayed or not.
				if (!self.isAllowPopup(popup) && !popup.classList.contains('age-verification')) {
					return;
				}

				self.openTriggerPopup(popup);
			});
		},

		/*
		* Trigger open popup
		*/
		openTriggerPopup: function (popup) {
			var trigger = popup.dataset.openTrigger;

			// Age Verification.
			if ('none' === trigger) {
				var ageVerification = self.getCookie('popup-age-' + (popup.dataset.id || 0));
				if (!ageVerification) self.openPopup(popup);
			}

			// Time Delay.
			if ('delay' === trigger) {
				setTimeout(function () {
					self.openPopup(popup);
				}, parseInt(popup.dataset.openDelayNumber) * 1000);
			}

			// Exit Intent.
			if ('exit' === trigger) {
				var showExit = true;
				document.addEventListener('mousemove', function (e) {
					var scroll = window.pageYOffset || document.documentElement.scrollTop;
					if ((e.pageY - scroll) < 7 && showExit) {
						self.openPopup(popup);
						showExit = false;
					}
				});
			}

			// Scroll Position.
			if ('scroll' === trigger) {
				var pointScrollType = popup.dataset.openScrollType;
				var pointScrollPosition = parseFloat(popup.dataset.openScrollPosition);

				document.addEventListener('scroll', function () {
					if ('px' === pointScrollType && window.scrollY >= pointScrollPosition) {
						self.openPopup(popup);
					}
					if ('%' === pointScrollType && self.getScrollPercent() >= pointScrollPosition) {
						self.openPopup(popup);
					}
				});
			}

			// Accept Agreement.
			if ('accept' === trigger) {
				var accept = self.getCookie('popup-accept-' + (popup.dataset.id || 0));
				if (!accept) self.openPopup(popup);
			}
		},

		/*
		* Trigger close popup
		*/
		closeTriggerPopup: function (popup) {
			var trigger = popup.dataset.closeTrigger;

			// Time Delay.
			if ('delay' === trigger) {
				setTimeout(function () {
					self.closePopup(popup);
				}, parseInt(popup.dataset.closeDelayNumber) * 1000);
			}

			// Scroll Position.
			if ('scroll' === trigger) {
				var pointScrollType = popup.dataset.closeScrollType;
				var pointScrollPosition = parseFloat(popup.dataset.closeScrollPosition);
				var initScrollPx = parseFloat(popup.dataset.initScrollPx);
				var initScrollPercent = parseFloat(popup.dataset.initScrollPercent);

				document.addEventListener('scroll', function () {
					if ('px' === pointScrollType) {
						if ('up' === self.sDirection && window.scrollY < (initScrollPx - pointScrollPosition)) {
							self.closePopup(popup);
						}
						if ('down' === self.sDirection && window.scrollY >= (initScrollPx + pointScrollPosition)) {
							self.closePopup(popup);
						}
					}
					if ('%' === pointScrollType) {
						if ('up' === self.sDirection && self.getScrollPercent() < (initScrollPercent - pointScrollPosition)) {
							self.closePopup(popup);
						}
						if ('down' === self.sDirection && self.getScrollPercent() >= (initScrollPercent + pointScrollPosition)) {
							self.closePopup(popup);
						}
					}
				});
			}
		},

		/*
		* Open popup
		*/
		openPopup: function (popup) {
			if (popup.classList.contains('popup-open')) return;
			if (popup.classList.contains('popup-already-opened')) return;

			// Hide body scroll.
			if (popup.getAttribute('data-body-scroll-disable') === 'true') {
				document.body.classList.add('popup-scroll-hidden');
			}

			// Set Cookie of Limit display.
			var limit = parseInt(self.getCookie('popup-' + popup.dataset.id) || 0) + 1;

			self.setCookie('popup-' + popup.dataset.id, limit, {
				expires: popup.dataset.limitLifetime
			});

			// Display popup.
			popup.classList.add('popup-open');

			// Set current scroll.
			popup.dataset.initScrollPx = window.scrollY;
			popup.dataset.initScrollPercent = self.getScrollPercent();

			// Open animation.
			var animation = popup.dataset.openAnimation;

			self.applyAnimation(popup, animation);

			// Init close trigger.
			self.closeTriggerPopup(popup);
		},

		/*
		* Age popup
		*/
		agePopup: function (el) {
			var popup = el.closest('.popup');
			if (!popup) return;
			self.setCookie('popup-age-' + popup.dataset.id, 1, { expires: 360 });
		},

		/*
		* Age declined
		*/
		ageDeclined: function () {
			var question = document.querySelector('.age-verification__question');
			var declined = document.querySelector('.age-verification__declined');
			if (question) question.classList.remove('show');
			if (declined) declined.classList.add('show');
		},

		/*
		* Accept popup
		*/
		acceptPopup: function (el) {
			var popup = el.closest('.popup');
			if (!popup) return;
			self.setCookie('popup-accept-' + popup.dataset.id, 1, { expires: 360 });
		},

		/*
		* Close popup
		*/
		closePopup: function (el) {
			var popup = el.closest('.popup');
			if (!popup) return;

			// Close animation.
			var animation = popup.dataset.exitAnimation;

			self.applyAnimation(popup, animation, function () {
				// Already opened.
				popup.classList.add('popup-already-opened');

				// Hide popup.
				popup.classList.remove('popup-open');

				// Remove classes from body.
				document.body.classList.remove('popup-scroll-hidden');
			});
		},

		/*
		* Checks whether a popup should be displayed or not
		*/
		isAllowPopup: function (popup) {
			var limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
			var limitDisplayCookie = parseInt(self.getCookie('popup-' + popup.dataset.id));

			if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) {
				return;
			}

			return true;
		},

		/*
		* Apply animation
		*/
		applyAnimation: function (el, name, callback) {
			var popup = el.closest ? el.closest('.popup') : el;
			if (!popup) return;

			var overlayName = typeof callback === 'function' ? 'popupExitFade' : 'popupOpenFade';

			// Overlay Animation.
			var overlay = popup.nextElementSibling;
			if (overlay && overlay.classList.contains('popup-overlay')) {
				overlay.classList.add('popup-animated', overlayName);
				overlay.addEventListener('animationend', function () {
					overlay.classList.remove('popup-animated', overlayName);
				}, { once: true });
			}

			// Wrap Animation.
			var wrap = popup.querySelector('.popup-wrap');
			if (wrap) {
				wrap.classList.add('popup-animated', name);
				wrap.addEventListener('animationend', function () {
					wrap.classList.remove('popup-animated', name);
					if (typeof callback === 'function') {
						callback();
					}
				}, { once: true });
			}
		},

		/*
		* Get cookie
		*/
		getCookie: function (name) {
			var matches = document.cookie.match(new RegExp(
				"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
			));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		/*
		* Set cookie
		*/
		setCookie: function (name, value, options) {
			options = options || {};

			options.path = options.hasOwnProperty('path') ? options.path : '/';

			options.expires = parseInt(options.expires);

			if (typeof options.expires == "number" && options.expires) {
				options.expires = new Date().setDate(new Date().getDate() + options.expires);
				options.expires = new Date(options.expires).toUTCString();
			}

			value = encodeURIComponent(value);

			var updatedCookie = name + "=" + value;

			for (var propName in options) {
				updatedCookie += "; " + propName;
				var propValue = options[propName];
				if (propValue !== true) {
					updatedCookie += "=" + propValue;
				}
			}

			document.cookie = updatedCookie;
		},

		/*
		* Get scroll percent
		*/
		getScrollPercent: function () {
			var h = document.documentElement,
				b = document.body;
			return (h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight) * 100;
		}
	};

	// Initialize.
	adpPopup.init();

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init();
	});

	document.addEventListener('shopify:section:unload', function () {
		document.body.classList.remove('popup-scroll-hidden');
	});
})();
